import { AudioControlsContainer } from "../../AudioControlsContainer";
import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { BoardManager } from "./BoardManger";
import { BoardScene } from "./BoardScene";

export class PauseLayer extends Phaser.GameObjects.Container {

    private darkLayer: Phaser.GameObjects.Graphics;
    private scaledItemsContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        this.darkLayer.fillStyle(0x2c241f, .6);
        this.darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(this.darkLayer);

        this.scaledItemsContainer = new Phaser.GameObjects.Container(scene);
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2 + 60;
        this.scaledItemsContainer.scaleX = GameVars.scaleX;
        this.add(this.scaledItemsContainer);

        const menuBackground = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "layer_small"); 
        this.scaledItemsContainer.add(menuBackground);

        const menuTitleBackground = new Phaser.GameObjects.Image(this.scene, -325, -195, "texture_atlas_1", "tab_boards_daily_games");
        menuTitleBackground.setOrigin(0);
        this.scaledItemsContainer.add(menuTitleBackground);

        const menuTitleLabel = new Phaser.GameObjects.Text(this.scene, menuTitleBackground.x + 30, menuTitleBackground.y + 20, gameText.MENU[lan], {fontFamily: "OpenSans-CondLight", fontSize: "52px", color: "#7C5D46"});
        menuTitleLabel.setOrigin(0);
        this.scaledItemsContainer.add(menuTitleLabel);

        const audioControlsContainer = new AudioControlsContainer(scene);
        audioControlsContainer.x = 55;
        this.scaledItemsContainer.add(audioControlsContainer);

        const resetLabel = new Phaser.GameObjects.Text(this.scene, 15, 160, gameText.RESET_LEVEL[lan], {fontFamily: "OpenSans-CondLight", fontSize: "36px", color: "#f6f5eb"});
        resetLabel.setOrigin(1, .5);
        this.scaledItemsContainer.add(resetLabel);

        const resetButton = new Button(this.scene, 70, resetLabel.y, "texture_atlas_1", "btn_reset_progress_off", "btn_reset_progress_on");
        resetButton.onDown(this.onClickResetButton, this);
        this.scaledItemsContainer.add(resetButton);

        const homeLabel = new Phaser.GameObjects.Text(this.scene, 220, -145, gameText.HOME[lan], {fontFamily: "OpenSans-CondLight", fontSize: "52px", color: "#7C5D46"});
        homeLabel.setOrigin(1, .5);
        this.scaledItemsContainer.add(homeLabel);

        const homeButton = new Button(this.scene, homeLabel.x + 55, homeLabel.y, "texture_atlas_1", "btn_home", "btn_home");
        homeButton.setInflationTween(1.1);
        homeButton.onDown(this.onClickHomeButton, this);
        this.scaledItemsContainer.add(homeButton);

        // ponemos 4 rectangulos
        const boundingBoxLeft = new Phaser.GameObjects.Rectangle(scene, 0, 0, 400, GameConstants.GAME_HEIGHT, 0xFF0000, GameConstants.DEVELOPMENT ? .5 : 0);
        boundingBoxLeft.setOrigin(0);
        boundingBoxLeft.setInteractive();
        boundingBoxLeft.on("pointerdown", this.onDownBoundingBox, this);
        this.add(boundingBoxLeft);

        const boundingBoxUp = new Phaser.GameObjects.Rectangle(scene, boundingBoxLeft.width, 0, 695, 290, 0x0000FF, GameConstants.DEVELOPMENT ? .5 : 0);
        boundingBoxUp.setOrigin(0);
        boundingBoxUp.setInteractive();
        boundingBoxUp.on("pointerdown", this.onDownBoundingBox, this);
        this.add(boundingBoxUp);

        const boundingBoxDown = new Phaser.GameObjects.Rectangle(scene, boundingBoxLeft.width, 715, 695, 255, 0x0000FF, GameConstants.DEVELOPMENT ? .5 : 0);
        boundingBoxDown.setOrigin(0);
        boundingBoxDown.setInteractive();
        boundingBoxDown.on("pointerdown", this.onDownBoundingBox, this);
        this.add(boundingBoxDown);

        const boundingBoxRight = new Phaser.GameObjects.Rectangle(scene, boundingBoxLeft.width + boundingBoxUp.width, 0, 405, GameConstants.GAME_HEIGHT, 0xFF0000, GameConstants.DEVELOPMENT ? .5 : 0);
        boundingBoxRight.setOrigin(0);
        boundingBoxRight.setInteractive();
        boundingBoxRight.on("pointerdown", this.onDownBoundingBox, this);
        this.add(boundingBoxRight);
    }

    private onDownBoundingBox(): void {

        BoardManager.pauseResumeGame();
    }

    private onClickResetButton(): void {
            
        const callbacks = {
            adFinished: () => {
                if (!GameVars.gameData.muted) {
                    AudioManager.unmute();
                }
                BoardManager.resetGame();
            },
            adError: (error, errorData) =>  {
                BoardManager.resetGame();
            },
            adStarted: () => {
                if (!GameVars.gameData.muted) {
                    AudioManager.mute();
                }
            }
        };

        const w = <any> window;
        w.CrazyGames.SDK.ad.requestAd("midgame", callbacks);
    }

    private onClickHomeButton(): void {

        GameManager.goBack();
    }
}
